import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { IconComponent } from '@libs/components/icons';
import { CtaListContentModel } from '@libs/cms/models';
import { ContentLinkDirective } from '@libs/shared/ui';
import { ContentBaseComponent } from '../content-base.component';

@Component({
  selector: 'ui-cta-list',
  templateUrl: './cta-list.component.html',
  styleUrls: ['./cta-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    ContentLinkDirective,
    IconComponent,
    MatButton,
  ],
})
export class CtaListComponent extends ContentBaseComponent<CtaListContentModel> {
}
